import { Text, Title, Tooltip } from '~components';
import { ReactComponent as QRCodeIcon } from '~assets/qr-code.svg';
import { ReactComponent as InformationCircleIcon } from '~assets/icons/information-circle.svg';
import * as styled from './styled';

function Card() {
  return (
    <styled.Wrapper>
      <div>
        <QRCodeIcon />
      </div>
      <div>
        <styled.Header>
          <Title>Escaneie o QR Code</Title>
          <Tooltip
            text="Aponte o celular pra o QR Code
            abrindo o app da câmera."
            placement="center"
            width="240px"
          >
            <styled.TooltipTextWrapper>
              <Text>Como fazer?</Text>
              <InformationCircleIcon />
            </styled.TooltipTextWrapper>
          </Tooltip>
        </styled.Header>
        <div>
          <Text color="neutral-strong">
            ou clique no link enviado por SMS direto do seu celular.
          </Text>
        </div>
      </div>
    </styled.Wrapper>
  );
}

export default Card;
